import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

interface GuidanceMessageProps {
  message: string | null;
  recovery?: boolean;
}

export const GuidanceMessage: React.FC<GuidanceMessageProps> = ({ message, recovery }) => {
  const { tm } = useI18n();
  return (
    <div className="h-12 flex items-center justify-center pointer-events-none">
      <AnimatePresence mode="wait">
        {message && (
          <motion.div
            key={message}
            data-testid="guidance-message-banner"
            initial={{ opacity: 0, y: 8, filter: "blur(4px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            exit={{ opacity: 0, y: -8, filter: "blur(4px)" }}
            transition={{ duration: 0.45, ease: "easeOut" }}
            className={`font-mono tracking-[0.35em] uppercase text-xl sm:text-2xl ${
              recovery ? "text-sky-200" : "text-amber-300"
            }`}
            style={{
              textShadow: recovery
                ? "0 0 20px rgba(56,189,248,0.5)"
                : "0 0 20px rgba(245,158,11,0.4)",
            }}
          >
            {tm("messages", message)}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
